/**
 * PDF layout `type` keys. Kronos used to persist translated labels because
 * PdfLayoutOptions stored `t('layouts.type_*').toLowerCase()` as the option
 * value (FR "Billet" → "billet"). Canonicalize on save; list filters must
 * keep matching the stored canonical key only. Engine migrates leftover
 * translated values.
 */

export const PDF_LAYOUT_TYPES = [
    'ticket',
    'ticket-bookings',
    'cart-receipt',
    'closing',
    'bill',
    'order',
    'screenings-programme',
];

const TYPE_ALIASES = {
    billet: 'ticket',
    eintrittskarte: 'ticket',
    biglietto: 'ticket',
    'bookings summary': 'ticket-bookings',
    'résumé de réservations': 'ticket-bookings',
    buchungsübersicht: 'ticket-bookings',
    'riepilogo delle prenotazioni': 'ticket-bookings',
    receipt: 'cart-receipt',
    quittance: 'cart-receipt',
    quittung: 'cart-receipt',
    ricevuta: 'cart-receipt',
    'clôture de caisse': 'closing',
    abschluss: 'closing',
    chiusura: 'closing',
    addition: 'bill',
    rechnung: 'bill',
    conto: 'bill',
    'préparation de commande': 'order',
    bestellung: 'order',
    ordine: 'order',
};

export function canonical_pdf_layout_type(type) {
    if (!type || typeof type !== 'string')
        return type;

    if (PDF_LAYOUT_TYPES.includes(type))
        return type;

    const key = type.trim().toLowerCase();
    if (PDF_LAYOUT_TYPES.includes(key))
        return key;

    return TYPE_ALIASES[key] || type;
}
